import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/product/components/organisms/Product/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'
import commonContext from '@/product/context/common/commonContext'
const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [anotherArray, setAnotherArray] = useState([])
    const { project_dynamicfields } = dynamicContext
    const customCommonContext = useContext(CustomCommonContext)
    const dashboardContext = useContext(commonContext)
    const { getMainDashboardData } = dashboardContext
    const history = useHistory()
    const [updated, setUpdated] = useState(false)
    const [categoryUpd, setCategoryUpd] = useState(false)
    const [updatedValues, setUpdatedValues] = useState({})
    const [asinMapData, setAsinMapData] = useState([])
    const settingcontext = useContext(SettingContext)
    const [homeMapData, setHomeMapData] = useState([])
    const {
        alldata_all_dropdown,
        getGlobalVariable,
        allConfigurationVariables,
    } = customCommonContext
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const categoryFilter = (value, fieldname) => {
        if (value) {
            let arrayData = [...project_dynamicfields]
            let filterValue = ''
            arrayData.map((data, index) => {
                if (data.type === 'select') {
                    if (value !== null) {
                        if (!data.diff_value) {
                            let idValue = {}
                            idValue =
                                alldata_all_dropdown &&
                                alldata_all_dropdown.filter(
                                    (item) =>
                                        item.description === `${value}` &&
                                        item.variable === `${fieldname}` &&
                                        item.active == 1
                                )
                            if (idValue.length) {
                                let values = idValue[0]
                                filterValue = values.id
                            }
                        }
                    }
                }
            })
            if (filterValue !== '') {
                return filterValue
            } else {
                searchTableAction(
                    {
                        id: 0,
                        value: null,
                        description: value,
                        variable: fieldname,
                        table: 'data_all_dropdown',
                        active: 1,
                    },
                    false,
                    'category_update'
                )
            }
        }
    }
    useEffect(() => {
        if (props.cyber) {
            if (props?.data) {
                setData((data) => {
                    return {
                        ...data,
                        popup: props?.data?.popup,
                        status: props?.data?.status,
                        id: props?.data?.id ? props?.data?.id : 0,
                        projectType: 0,
                    }
                })
            }
        } else {
            if (props?.match?.params?.id && props?.match?.params?.status) {
                setData({
                    popup: true,
                    status: props?.match?.params?.status,
                    id: props?.match?.params?.id,
                    projectType: 0,
                })
            }
        }
        const filterBody = {
            filterRange: true,
            search: 'within',
            within: 'month',
        }
        getMainDashboardData(
            global.customDashboardFilter
                ? { ...global.customDashboardFilter, ...filterBody }
                : filterBody
        )
    }, [props?.match?.params?.id, props?.match?.params?.status, props?.data])
    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (
                    responseStatusSetting.from === 'category_update' &&
                    updated
                ) {
                    setUpdated(false)
                    getGlobalVariable()
                    setTimeout(() => {
                        setCategoryUpd(true)
                    }, 4000)
                    // setReload(!reload)
                    clearResponseCommuncation()
                }
            }
        }
    }, [responseStatusSetting, updated])
    useEffect(() => {
        if (alldata_all_dropdown && categoryUpd) {
            anotherArray.map((data) => {
                if (data.name == 'category') {
                    data.initialDefault = categoryFilter(
                        props.data.data.category,
                        'category'
                    )
                }
            })
            setFieldValue(anotherArray)
            setCategoryUpd(false)
        }
    }, [alldata_all_dropdown, categoryUpd])
    useEffect(() => {
        if (
            props.data?.data &&
            anotherArray.length &&
            Object.keys(props.data.data).length
        ) {
            setCategoryUpd(false)
            let allData = [...anotherArray]
            const cyberData = props.data?.data
            allData.map((item) => {
                if (props?.cyber && cyberData) {
                    if (
                        item.name === 'category' &&
                        cyberData.category !== '' &&
                        !updated
                    ) {
                        let category = categoryFilter(
                            cyberData.category,
                            'category'
                        )
                        if (category) {
                            item.initialDefault = category
                        }
                        setUpdated(true)
                    }
                    if (item.name === 'title') {
                        item.initialDefault = cyberData.title
                    }
                    if (item.name === 'desc_proc') {
                        item.initialDefault = cyberData.description
                    }
                    if (item.name === 'retail_price') {
                        item.initialDefault = cyberData.price
                    }
                    if (item.name === 'uploadimages') {
                        item.initialDefault = [cyberData.image]
                    }
                    if (item.name === 'payments_details') {
                        item.initialDefault =
                            allConfigurationVariables?.payments_details || ''
                    }
                    if (item.name === 'shipping_details') {
                        item.initialDefault =
                            allConfigurationVariables?.shipping_details || ''
                    }
                    if (item.name === 'returns_details') {
                        item.initialDefault =
                            allConfigurationVariables?.returns_details || ''
                    }
                }
            })

            setFieldValue(allData)
        }
    }, [props.data?.data, anotherArray])
    const [fieldValue, setFieldValue] = useState([])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []
            let projectType = props?.data?.projectType
            projectDynamicArray
                .filter((data) => data.active === 1)
                .map((item) => {
                    if (item.view_on && projectType) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 1
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                            }
                            if (item.name == 'scan_lpn_number') {
                                item.scanBarcode = global?.scanBarcode
                                    ? global?.scanBarcode
                                    : false
                            }
                            if (item.name == 'bin_location') {
                                item.scanBarcode = global?.scanBarcode
                                    ? global?.scanBarcode
                                    : false
                            }
                            if (item.name == 'tub_bin') {
                                item.scanBarcode = global?.scanBarcode
                                    ? global?.scanBarcode
                                    : false
                            }
                            if (
                                item.name === 'asin' ||
                                item.name === 'home_depot' ||
                                item.name === 'upc_id' ||
                                item.name === 'x_barcode'
                            ) {
                                item.scanBarcode = global?.scanBarcode
                                    ? global?.scanBarcode
                                    : false
                            }
                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name === 'sprice') {
                            item.initialDefault = 1
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                        }
                        if (item.name == 'scan_lpn_number') {
                            item.scanBarcode = global?.scanBarcode
                                ? global?.scanBarcode
                                : false
                        }
                        if (item.name == 'bin_location') {
                            item.scanBarcode = global?.scanBarcode
                                ? global?.scanBarcode
                                : false
                        }
                        if (item.name == 'tub_bin') {
                            item.scanBarcode = global?.scanBarcode
                                ? global?.scanBarcode
                                : false
                        }
                        if (
                            item.name === 'asin' ||
                            item.name === 'home_depot' ||
                            item.name === 'upc_id' ||
                            item.name === 'x_barcode'
                        ) {
                            item.scanBarcode = global?.scanBarcode
                                ? global?.scanBarcode
                                : false
                        }
                        dynamicValueAssign.push(item)
                    }
                })
            dynamicValueAssign.push(
                {
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'asin_id',
                    value: '',
                    active: 1,
                },
                {
                    name: 'auctiontype',
                    value: 'live',
                    type: 'default',
                    active: 1,
                }
            )
            setFieldValue(dynamicValueAssign)
            setAnotherArray(dynamicValueAssign)
        }
    }, [project_dynamicfields, props.data, props.data?.data])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    const closeFunction = () => {
        history.goBack()
    }
    return (
        <>
            {props.cyber ? (
                <>
                    <ProductFieldsView
                        fieldValue={fieldValue}
                        userId={props.userId}
                        data={data}
                        showasin={global?.showasin ? global.showasin : false}
                        homeDepot={global?.homeDepot ? global.homeDepot : false}
                        function={props.function}
                        asinMapData={asinMapData}
                        homeMapData={homeMapData}
                        additionalFieldUpdate={additionalFieldUpdate}
                        closeFunction={closeFunction}
                        customFilter={props.customFilter}
                        standalone={
                            typeof props.insidePage !== 'undefined'
                                ? props.insidePage
                                : global.standalone
                                  ? global.standalone
                                  : false
                        }
                    />
                </>
            ) : (
                <>
                    <Layout>
                        <ProductFieldsView
                            fieldValue={fieldValue}
                            userId={props.userId}
                            data={data}
                            showasin={
                                global?.showasin ? global.showasin : false
                            }
                            homeDepot={
                                global?.homeDepot ? global.homeDepot : false
                            }
                            function={props.function}
                            asinMapData={asinMapData}
                            homeMapData={homeMapData}
                            additionalFieldUpdate={additionalFieldUpdate}
                            closeFunction={closeFunction}
                            customFilter={props.customFilter}
                            standalone={
                                global.standalone ? global.standalone : false
                            }
                        />
                    </Layout>
                </>
            )}
        </>
    )
}

export default DynamicListing
